import React, { useState } from 'react';
import { Icon, Modal } from 'Components';
import LMSButton from 'LearningManager/components/Button';
import MultiSelectDropdown from 'LearningManager/components/MultiSelectDropdown';
import styles from './CourseUnassignModal.module.scss';

export interface CourseUnassignAssignmentOption {
	id: number;
	label: string;
}

interface CourseUnassignModalProps {
	visible: boolean;
	options: CourseUnassignAssignmentOption[];
	learnerCount?: number;
	onCancel: () => void;
	onConfirm: (assignmentIds: number[]) => void;
}

const CourseUnassignModal: React.FC<CourseUnassignModalProps> = ({
	visible,
	options,
	learnerCount = 0,
	onCancel,
	onConfirm
}) => {
	const [selectedIds, setSelectedIds] = useState<number[]>([]);

	const hasSelection = selectedIds.length > 0;

	const handleCancel = () => {
		setSelectedIds([]);
		onCancel();
	};

	const handleConfirm = () => {
		onConfirm(selectedIds);
		setSelectedIds([]);
	};

	return (
		<Modal
			visible={visible}
			title="Unassign courses?"
			onCancel={handleCancel}
			size="sm"
			destroyOnClose
			className={styles.modal}
			footer={
				<div className={styles.footer}>
					<LMSButton
						size="small"
						variant="borderless"
						type="default"
						onClick={handleCancel}
					>
						Cancel
					</LMSButton>
					<LMSButton
						type="primary"
						size="small"
						disabled={!hasSelection}
						onClick={handleConfirm}
					>
						Unassign
					</LMSButton>
				</div>
			}
		>
			<div className={styles.body}>
				<p className={styles.text}>
					Select the assignment(s) you want to unassign this course
					from.
				</p>
				<div className={styles.field}>
					<div className={styles.field__label}>Assignment</div>
					<MultiSelectDropdown
						options={options}
						placeholder="Select assignment"
						defaultSelectedIds={[]}
						onChange={setSelectedIds}
						allLabel="All Assignments"
						showValueInBraces
						className={styles.dropdown}
					/>
				</div>

				{hasSelection && (
					<div className={styles.summary}>
						<p className={styles.text}>
							Unassigning this courses will:
						</p>
						<ul className={styles.list}>
							<li>Affect {learnerCount} learners total</li>
						</ul>
						<div className={styles.warning}>
							<Icon type="warningFilledIcon" role="img" />
							This action cannot be undone. All progress data will
							be lost.
						</div>
					</div>
				)}
			</div>
		</Modal>
	);
};

export default CourseUnassignModal;
